"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContent = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const loader_1 = require("@festival/component/loader");
const classnames_1 = require("classnames");
class ListContent extends React.Component {
    render() {
        const { pageConfigurationStore, routeManager } = this.props;
        if (!pageConfigurationStore || !routeManager) {
            return null;
        }
        const press = pageConfigurationStore.get('press');
        if (!press) {
            return null;
        }
        if (!press.complete) {
            return React.createElement(loader_1.default, null);
        }
        const pressComplete = press;
        if (!pressComplete.details) {
            return null;
        }
        return this.renderContent(pressComplete.details, routeManager);
    }
    renderContent(details, routeManager) {
        const { className } = this.props;
        return (React.createElement("div", { id: "press", className: classnames_1.default(className) },
            details.managerName && details.managerMail && (React.createElement(reactstrap_1.Card, { body: true, className: "my-2" },
                React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.press-manager.title" })),
                React.createElement("p", null,
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.press-manager.content" })),
                React.createElement("h3", null,
                    details.managerName,
                    " : ",
                    React.createElement("a", { href: `mailto:${details.managerMail}` }, details.managerMail)))),
            details.medias && (React.createElement(reactstrap_1.Card, { body: true, className: "my-2" },
                React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.medias.title" })),
                React.createElement("p", null,
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.medias.content" })),
                details.medias.length > 0 ? (React.createElement("ul", { className: "list-inline" }, details.medias.map((document, index) => (React.createElement("li", { key: index, className: "list-inline-item" },
                    React.createElement(reactstrap_1.Button, { tag: "a", href: document.available ? document.link : '#', target: "_blank", rel: "noreferrer", disabled: !document.available || !document.link }, document.title)))))) : (React.createElement(reactstrap_1.Alert, { color: "warning" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.medias.empty" }))))),
            details.pressReleases && (React.createElement(reactstrap_1.Card, { body: true, className: "my-2" },
                React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.press-releases.title" })),
                React.createElement("p", null,
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.press-releases.content" })),
                details.pressReleases.length > 0 ? (React.createElement("ul", { className: "list-inline" }, details.pressReleases.map((document, index) => (React.createElement("li", { key: index, className: "list-inline-item" },
                    React.createElement(reactstrap_1.Button, { tag: "a", href: document.available ? document.link : '#', target: "_blank", rel: "noreferrer", disabled: !document.available || !document.link }, document.title)))))) : (React.createElement(reactstrap_1.Alert, { color: "warning" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.press-releases.empty" }))))),
            React.createElement(reactstrap_1.Card, { body: true, className: "my-2" },
                React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.accreditation.title" })),
                React.createElement("p", null,
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.accreditation.content" })),
                React.createElement(react_router_dom_1.Link, { to: routeManager.generate('press-contact') },
                    React.createElement(react_intl_1.FormattedMessage, { id: "press.accreditation.link" })))));
    }
}
exports.ListContent = ListContent;
exports.default = mobx_react_1.inject('pageConfigurationStore', 'routeManager')(mobx_react_1.observer(ListContent));
